<template>
<div class="chapter">
<div class="inner_page">
<div id="PROLOGUE.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="ch"><a id="Anchor-1"></a>PROLOGUE</p>
<p class="sub">Brest, <em class="italic">France<br/>August 5, 1791</em></p>
<p class="body-text-opening"><span class="sc" xml:lang="en-US">H</span><span class="sc-epub" xml:lang="en-US">ER</span><span class="sc" xml:lang="en-US"> </span><span class="sc-epub" xml:lang="en-US">DAUGHTER</span><span class="sc" xml:lang="en-US"> </span><span class="sc-epub" xml:lang="en-US">WOULD</span><span class="sc" xml:lang="en-US"> </span>not stop crying.
					Evelyn held her, silently begging her to be quiet, as their carriage raced
					through the darkness. The road was rough, especially at their frantic pace, and
					the constant lurching and jostling did not help. If only Aimee would sleep!
					Evelyn feared they had been followed; she was also afraid that her daughter’s
					cries would cause suspicion and bring undue attention to them even if they had
					successfully escaped Paris.</p>
<p class="body-text">But Aimee was frightened—because her mother was frightened.
					Children could sense such things. But Evelyn was afraid because Aimee was the
					most important thing in her life, and she would die to keep her safe.</p>
<p class="body-text">And what if Henri died?</p>
<p class="body-text">Evelyn D’Orsay hugged her daughter, who had recently turned
					four, harder. She was seated in the front of the carriage with the driver,
					Laurent, her husband’s valet, now turned jack-of-all-trades. Her husband was
					slumped in the backseat, unconscious, seated between Laurent’s wife, Adelaide,
					and her own ladies’ maid, Bette. She glanced back now, her heart lurching with
					alarm. Henri remained deathly white.</p>
<p class="body-text">His health had begun to fail him sometime after Aimee had been
					born. He had also become consumptive. Was his heart failing him now? Could he
					survive this mad, frightening dash through the night? Would he survive the
					Channel crossing? Evelyn knew he needed a doctor, desperately, just as she knew
					this wild carriage ride could not be helpful to him.</p>
<p class="body-text">But if they could make it out of France, if they could make it
					to Britain, they would be safe.</p>
<p class="body-text">“How far are we?” she whispered. Luckily Aimee had stopped
					crying; in fact, she had fallen asleep.</p>
<p class="body-text">“I think we are almost there,” Laurent said. They were speaking
					French. Evelyn was an Englishwoman, but she had been fluent in French even
					before she had met the Count D’Orsay, becoming his child bride almost
					overnight.</p>
<p class="body-text">The horses were lathered and blowing hard. Fortunately, they
					did not have much farther to go—or so Laurent thought. And it would soon be
					dawn. At dawn, they were to disembark with a Belgian smuggler, who was awaiting
					them even now.</p>
<p class="body-text">“Will we be late?” she asked, keeping her tone low, which was a
					bit absurd, as the coach rattled and groaned with the horses’ every stride.</p>
<p class="body-text">“I think we will have an hour to spare,” Laurent said, “but not
					much more than that.” He glanced briefly at her, his look a significant one.</p>
<p class="body-text">She knew what he was thinking now—they were all thinking it. It
					had been so hard to escape Paris. There would be no going back, not even to
					their country home in the Loire Valley. They must leave France if they were to
					survive. Their lives were at stake.</p>
<p class="body-text">Aimee was sound asleep. Evelyn stroked her soft, dark hair and
					fought her own need to weep with fear and desperation.</p>
<p class="body-text">She glanced back at her elderly husband again. Since meeting
					and marrying Henri, her life had felt so much like a fairy tale. She had been a
					penniless orphan, subsisting on the charity of her aunt and uncle; now, she was
					the Countess D’Orsay. He was her dearest friend, and the father of her daughter.
					She was so grateful to him for all that he had done for her, and all he meant to
					do for Aimee.</p>
<p class="body-text">She was so afraid for him now. His chest had been bothering him
					all day. But he had survived their flight from Paris, and Henri had insisted
					that they must not delay. Their neighbor had been imprisoned last month for
					crimes against the state. The Vicomte LeClerc had not committed any crimes—she
					was sure of it. But he was an aristocrat....</p>
<p class="body-text">Their usual residence was Henri’s family estate in the Loire
					Valley. But every spring Henri would pack up the family and they would go to
					Paris for a few months of theater, shopping and dining. Evelyn had fallen in
					love with Paris the very first time she had set foot in the city, before the
					revolution. But the city she had once loved no longer existed, and had they
					realized how dangerous Paris had become, they wouldn’t have gone for another
					visit.</p>
<p class="body-text">In spite of the revolution, Paris remained flooded with
					unemployed workers, laborers and farmers, who roamed the streets seeking revenge
					upon anyone who had anything, unless they were striking or rioting. Taking a
					stroll down the Champs-Élysées was no longer pleasant, nor was riding in the
					park. There were no more interesting supper parties, no more scintillating
					operas. Shops catering to the nobility had long since closed their doors.</p>
<p class="body-text">The fact that her husband, the comte, was a relation of the
					queen had never been a secret. But the moment a hatmaker had realized the
					connection, their lives had suddenly and truly changed. Shopkeepers, bakers,
					prostitutes, sansculottes and even National Guardsmen had kept watch upon her
					and her family at their townhome. Every time her door was opened, sentinels
					could be seen standing outside. Every time she left the flat she had been
					followed. It had become too frightening to venture outside of the apartment. It
					was as if they were suspected of crimes against the state. And then LeClerc had
					been arrested.</p>
<p class="body-text">“Your time will come.” A passerby had leered at her the day
					their neighbor was taken away in shackles.</p>
<p class="body-text">And Evelyn had become afraid to go out. She had ceased doing
					so. From that moment, they had become actual prisoners of the people. She had
					begun to believe that they would not be allowed to leave the city, if they
					tried. And then a pair of French officers had called on Henri. Evelyn had been
					terrified that they were about to arrest him. Instead, they had warned him that
					he must not leave the city until given permission to do so and that Aimee must
					remain in Paris with them. And the fact that they had said so—that they even
					knew about Aimee—had triggered them as nothing else could. They had immediately
					begun planning their escape.</p>
<p class="body-text">And it was Henri who had suggested they follow in the wake of
					the thousands of émigrés now fleeing France for Great Britain. Evelyn had been
					born and raised in Cornwall, and once she had realized that they were going
					home, she had been thrilled. She had missed the rocky beaches of Cornwall, the
					desolate moors, the winter storms, the blunt, outspoken women and the
					hardworking men. She missed taking tea at the nearby village inn, and the wild
					celebrations that ensued when a smuggler arrived with his precious cargo. Life
					in Cornwall could be difficult and harsh, but it had its softer moments. Of
					course, they would probably reside in London, but she also loved the city. She
					couldn’t imagine a better—safer—country in which to raise her daughter.</p>
<p class="body-text">Aimee deserved so much more. And she did not deserve to become
					another innocent victim of this terrible revolution!</p>
<p class="body-text">But first they had to get from Brest to the smuggler’s ship,
					and then they had to get across the Channel. And Henri had to survive.</p>
<p class="body-text">She felt the surge of panic and she trembled. Henri needed a
					doctor, and she was tempted to delay their flight to attend him. She could not
					imagine what she would do if he died. But she also knew he wanted her and Aimee
					safely out of the country. In the end, she would put her daughter first.</p>
<p class="body-text">“Has he shown any signs of reviving?” she cried, glancing over
					her shoulder.</p>
<p class="body-text">“<em class="italic">Non, </em>Comtesse,” Adelaide
					whispered. “<em class="italic">Le comte </em>needs a physician soon!”</p>
<p class="body-text">If they delayed, in order to attend Henri, they would remain in
					Brest for another day or perhaps even more. Within hours, or at least by this
					evening, their disappearance would be noticed. Would they be pursued? It was
					impossible to know, except that the officials had warned them not to leave the
					city and they had defied that edict. If there was pursuit, there were two
					obvious ports to search—Brest and Le Havre were the most frequently used ports
					of departure.</p>
<p class="body-text">There was no choice to make. Evelyn clenched her fists, filled
					with determination. She was not accustomed to making decisions, and especially
					not important ones, but in another hour they would be safely at sea, and out of
					reach of their French pursuers, if they did not delay.</p>
<p class="body-text">They had reached the outskirts of Brest, and were passing many
					small houses now. She and Laurent exchanged dark, determined looks.</p>
<p class="body-text">A few moments later, salt tinged the air. Laurent drove the
					team into the graveled courtyard of an inn that was just three blocks from the
					docks. The night was now filled with scudding clouds, at times in darkness, at
					other times, brightened by the moon. As Evelyn handed her daughter down to
					Bette, her tension intensified. The inn seemed busy—loud voices could be heard
					coming from the public room. Perhaps that was better—it was so crowded, no one
					would pay attention to them now.</p>
<p class="body-text">Or perhaps they would.</p>
<p class="body-text">Evelyn waited with Aimee, asleep in her arms, while Laurent
					went inside to get help for her husband. She was clothed in one of Bette’s
					dresses and a dark, hooded mantle that had been worn by another servant. Henri
					was also dressed as a commoner.</p>
<p class="body-text">And finally Laurent and the innkeeper appeared. Evelyn slipped
					up her hood as he approached—her looks were too remarkable to go unnoticed—and
					cast her eyes down. The two men lifted Henri from the carriage and carried him
					inside, using a side entrance. Holding Aimee Evelyn followed with Adelaide and
					Bette. They quickly went upstairs.</p>
<p class="body-text">Evelyn closed the door behind her two women servants, daring to
					breathe with some relief, but not yet daring to remove her hood. She signaled
					Adelaide with her eyes, not wanting her to light more than one candle.</p>
<p class="body-text">If their disappearance had been noted, the French authorities
					might have put out warrants for their arrests. Descriptions would accompany
					those warrants and their pursuers would be looking for a little girl of four
					with dark hair and blue eyes, a sickly and frail older nobleman of medium height
					with gray hair and a young woman of twenty-one, dark-haired, blue-eyed and
					fair-skinned, one remarkably beautiful in appearance.</p>
<p class="body-text">Evelyn feared that she was too distinct in her appearance. She
					was too recognizable, and not just because she was so much younger than her
					husband. When she had first come to Paris, as a bride of sixteen, she had been
					acclaimed the city’s most beautiful woman. She hardly thought that, but she knew
					her looks were striking and hard to miss.</p>
<p class="body-text">Henri had been made comfortable in one bed, and Aimee in
					another. Laurent and the innkeeper had stepped aside, and were speaking in
					hushed tones. Evelyn thought that they were both grim, but there was urgency in
					the situation. She smiled at Bette, who was tearful and so clearly frightened.
					Bette had been given the choice of going home to her family in Le Loire. She had
					chosen instead to come with them, fearing being hunted down and interrogated if
					she did not.</p>
<p class="body-text">“It will be all right,” Evelyn said softly, hoping to reassure
					her. They were the same age, but suddenly Evelyn felt years older. “In a matter
					of moments, we will be on a ship, bound for England.”</p>
<p class="body-text">“Thank you, my lady,” Bette whispered, sitting down beside
					Aimee.</p>
<p class="body-text">Evelyn smiled again, then walked over to Henri. She took his
					hand and kissed his temple. He remained terrifyingly pale. She would not be able
					to bear it if he died. She could not imagine losing such a dear friend. And she
					knew just how dependent she was on him.</p>
<p class="body-text">She was not certain that her aunt and uncle would welcome her
					back into their home, if need be. But that would be a last recourse, anyway.</p>
<p class="body-text">The innkeeper left and Evelyn quickly hurried over to Laurent,
					who seemed stricken. “What has happened?” she asked, with another curdling
					sensation.</p>
<p class="body-text">“Captain Holstatter has left Brest.”</p>
<p class="body-text">“What?” she cried, aghast. “You must be mistaken. It is August
					the fifth. We are on time. It is almost dawn. In another hour, he is taking us
					to Falmouth—he has been paid half of his fee in advance!”</p>
<p class="body-text">Laurent was starkly white. “He happened upon a very valuable
					cargo, and he left.”</p>
<p class="body-text">She was in shock. They had no means of crossing the Channel!
					And they could not linger in Brest—it was too dangerous!</p>
<p class="body-text">“There are three British smugglers in the harbor,” Laurent
					said, interrupting her thoughts.</p>
<p class="body-text">There was a reason they had chosen a Belgian to take them to
					England. “British smugglers are usually French spies,” she cried.</p>
<p class="body-text">“If we are going to leave immediately, the only choice is to
					seek out one of them, or wait here, until we can make other arrangements.”</p>
<p class="body-text">Her head ached again. How was it that she was making the most
					important decision of their lives? Henri always made all of the decisions! And
					the way Laurent was looking at her, she knew he was thinking the same thing she
					was—that remaining in town was not safe. She turned and glanced at Aimee. Her
					heart lurched. “We will leave at dawn, as planned,” she decided abruptly, her
					heart slamming. “I will make certain of it!”</p>
<p class="body-text">Trembling, she turned and went to a valise that was beside the
					bed. They had fled the city with a great number of valuables. She took a pile of
					assignats from it, the currency of the revolution, and then, instinctively, took
					out a magnificent ruby-and-diamond necklace. It had been in her husband’s family
					for years. She tucked both within the bodice of her corset.</p>
<p class="body-text">Laurent said, “If you will use one of the Englishmen, Monsieur
					Gigot, the innkeeper, said to look for a ship named the <em class="italic">Sea
						Wolf.</em>”</p>
<p class="body-text">She choked on hysterical laughter, turning. Was she
					<br/>really going alone to meet a dangerous smuggler—at dawn and in the dark,
					in a strange city, with her husband near death—to beg for his help?</p>
<p class="body-text">“His ship is the swiftest, and they say he can outrun both
					navies at once. It is fifty tons, black sails—the largest of the smuggling
					vessels in the harbor.”</p>
<p class="body-text">She shuddered, nodding grimly. The <em class="italic">Sea
						Wolf…</em>black sails… “How do I get to the docks?”</p>
<p class="body-text">“They are three blocks from the inn,” Laurent told her. “I
					think I should come with you.”</p>
<p class="body-text">She was tempted to agree. But what if someone discovered them
					while she was gone—what if someone realized who Henri was? “I want you to stay
					here and guard <em class="italic">le comte</em> and Aimee with your life.
					Please,” she added, consumed with another intense wave of desperation.</p>
<p class="body-text">Laurent nodded and walked her to the door. “The smuggler’s name
					is Jack Greystone.”</p>
<p class="body-text">She wanted to cry. Of course, she would do no such thing. She
					pulled up her hood and gave her sleeping daughter one last look.</p>
<p class="body-text">Evelyn knew she would find Greystone, and convince him to
					transport them across the Channel, because Aimee’s future depended on it.</p>
<p class="body-text">She hurried from the room, and waited to hear Laurent slide the
					bolt on the door’s other side, before she rushed down the narrow, dark corridor.
					One taper burned from a wall sconce at the far end of the hall, above the
					stairs. She stumbled down the single flight, thinking of Aimee, of Henri and a
					smuggler with a ship named the <em class="italic">Sea Wolf.</em></p>
<p class="body-text">The landing below let onto the inn’s foyer, and just to her
					right was the public room. A dozen men were within, drinking spirits, the
					conversation boisterous. She rushed outside, hoping no one had noticed her.</p>
<p class="body-text">Clouds raced across the moon, allowing some illumination. One
					torch lamp was lit on the street. Evelyn ran down the block, but saw no one
					ahead and no one lurking in the shadows. Relieved, she glanced back over her
					shoulder. Her heart seemed to stop.</p>
<p class="body-text">Two dark figures were behind her now.</p>
<p class="body-text">She began to run, seeing several masts in the sky ahead, pale
					canvas furled tightly against them. Another glance over her shoulder showed her
					that the men were also running—they were most definitely following her.</p>
<p class="body-text"><em class="italic">“Arrêtez-vous!”</em> one of the men
					called, laughing. “Are we frightening you? We only wish to speak with you!”</p>
<p class="body-text">Fear slammed through her. Evelyn lifted her skirts and ran
					toward the docks, which were now in front of her. And she instantly saw that
					cargo was being loaded onto one of the vessels—a cask the size of several men
					had been winched up and was being directed toward the deck of a large cutter
					with a black hull and black sails. Five men stood on the deck, reaching for the
					cask as it was lowered toward them.</p>
<p class="body-text">She had found the <em class="italic">Sea Wolf.</em></p>
<p class="body-text">She halted, panting and out of breath. Two men were operating
					the winch. A third stood a bit apart, watching the activity. Moonlight played
					over his pale hair.</p>
<p class="body-text">And she was seized from behind.</p>
<p class="body-text"><em class="italic">“Nous voulons seulement vous parler.” We
						only want to speak to you.</em></p>
<p class="body-text">Evelyn whirled to face the two men who had been following her.
					They were her own age, dirty, unkempt and poorly clothed—they were probably
					farmworkers and thugs. <em class="italic">“Libérez-moi,”</em> she responded
					in perfect French.</p>
<p class="body-text">“A lady! A lady dressed as a maid!” the first man said, but he
					did not speak with relish now. He spoke with suspicion.</p>
<p class="body-text">Too late, she knew she was in more danger than the threat of
					being accosted—she was about to be unmasked as a noblewoman and, perhaps, as the
					Countess D’Orsay. But before she could respond, a stranger said, very quietly,
					in English, “Do as the lady has asked.”</p>
<p class="body-text">The farmers turned, as did Evelyn. The clouds chose that moment
					to pass completely by the moon, and the night became momentarily brighter.
					Evelyn looked into a pair of ice-cold gray eyes and she froze.</p>
<p class="body-text"><em class="italic">This man was dangerous.</em></p>
<p class="body-text">His stare was cold and hard. He was tall, his hair golden. He
					wore both a dagger and a pistol. Clearly, he was not a man to be crossed.</p>
<p class="body-text">His cool glance left her and focused on the two men. He
					repeated his edict, this time in French. <em class="italic">“Faites comme la
						dame a demandé.”</em></p>
<p class="body-text">She was instantly released, and both men whirled and hurried
					off. Evelyn inhaled, stunned, and turned to the tall Englishman again. He might
					be dangerous, but he had just rescued her—and he might be Jack Greystone. “Thank
					you.”</p>
<p class="body-text">His direct gaze did not waver. It was a moment before he said,
					“It was my pleasure. You’re English.”</p>
<p class="body-text">She wet her lips, aware that their gazes were locked. “Yes. I
					am looking for Jack Greystone.”</p>
<p class="body-text">His eyes never changed. “If he is in port, I am not aware of
					it. What do you want of him?”</p>
<p class="body-text">Her heart sank with dismay—for surely, this imposing man, with
					his air of authority and casual power, was the smuggler. Who else would be
					watching the black ship as it was being loaded? “He has come recommended to me.
					I am desperate, sir.”</p>
<p class="body-text">His mouth curled, but there was no humor in his eyes. “Are you
					attempting to return home?”</p>
<p class="body-text">She nodded, still staring at him. “We had arrangements to leave
					at dawn. But those plans have fallen by the wayside. I was told Greystone is
					here. I was told to seek him out. I cannot linger in town, sir.”</p>
<p class="body-text">“We?”</p>
<p class="body-text">She hugged herself now, still helplessly gazing into his stare.
					“My husband and my daughter, sir, and three friends.”</p>
<p class="body-text">“And who gave you such information?”</p>
<p class="body-text">“Monsieur Gigot—of the Abelard Inn.”</p>
<p class="body-text">“Come with me,” he said abruptly, turning.</p>
<p class="body-text">Evelyn hesitated as he started toward the ship. Her mind raced
					wildly. She did not know if the stranger was Greystone, and she wasn’t certain
					it was safe to go with him now. But he was heading for the ship with black
					sails.</p>
<p class="body-text">He glanced back at her, without pausing. And he shrugged,
					clearly indifferent as to whether she came or not.</p>
<p class="body-text">There was no choice. Either he was Greystone, or he was taking
					her to him. Evelyn ran after him, following him up the gangplank. He didn’t look
					at her, crossing the deck rapidly, and Evelyn rushed to fall into step behind
					him. The five men who were loading the cask all turned to stare openly at
					her.</p>
<p class="body-text">Her hood had slipped. She pulled it up more tightly as he went
					to a cabin door. He opened it and vanished inside. She faltered. She had just
					noticed the guns lining the sides of the ship. She had seen smuggling ships as a
					child; this ship seemed ready to do battle.</p>
<p class="body-text">She was even more dismayed and full of dread, but she had made
					her decision. Evelyn followed him inside.</p>
<p class="body-text">He was lighting lanterns. Not looking up, he said, “Close the
					door.”</p>
<p class="body-text">It crossed her mind that she was very much alone with a
					complete stranger now. Shoving her trepidation aside, she did as he asked. Very
					breathless now, she slowly faced him.</p>
<p class="body-text">He was standing at a large desk covered with charts. For one
					moment, all she saw was a tall, broad-shouldered man with golden hair tied
					carelessly in a queue, a pistol clipped to his shoulder belt, a dagger sheathed
					on his belt.</p>
<p class="body-text">Then she realized that he was also staring at her.</p>
<p class="body-text">She inhaled, trembling. He was shockingly attractive, she now
					realized, in both a masculine and a beautiful way. His eyes were gray, his
					features even, his cheekbones high and cutting. A gold cross winked from the
					widely open neck of his white lawn shirt. He was wearing doeskin breeches and
					high boots, and now she realized how powerful and lean his tall, muscular build
					was. His shirt clung to his broad chest and flat torso, and his breeches fit
					like a second skin. He did not have an ounce of fat on his hard frame.</p>
<p class="body-text">She wasn’t certain she had ever come into contact with such an
					inherently masculine man—and it was unnerving somehow.</p>
<p class="body-text">She was also the object of intense scrutiny. He was leaning his
					hip against the desk and staring back at her, as openly as she was regarding
					him. Evelyn felt herself flush. He was, she thought, trying to see her features,
					which were partially concealed by her hood.</p>
<p class="body-text">She now saw the small, narrow bed on the opposite wall. She
					realized that this was where he slept. There was a handsome rug on the planked
					floor, a handful of books on a small table. Otherwise, the cabin was sparsely
					appointed and completely utilitarian.</p>
<p class="body-text">“Do you have a name?”</p>
<p class="body-text">She jerked, realizing that her heart was racing. How should she
					answer? For she knew she must never reveal who she was. “Will you help me?”</p>
<p class="body-text">“I haven’t decided. My services are expensive, and you are a
					large group.”</p>
<p class="body-text">“I am desperate to return home. And my husband is in desperate
					need of a physician.”</p>
<p class="body-text">“So the plot thickens. How ill is he?”</p>
<p class="body-text">“Does it matter?”</p>
<p class="body-text">“Can he reach my ship?”</p>
<p class="body-text">She hesitated. “Not without help.”</p>
<p class="body-text">“I see.”</p>
<p class="body-text">He did not seem moved by her plight. How could she convince him
					to help them? “Please,” she whispered, stepping away from the door. “I have a
					four-year-old daughter. I must get her to Britain.”</p>
<p class="body-text">He suddenly launched himself off the desk and strode
					slowly—indolently—toward her. “Just how desperate are you?” His tone was
					flat.</p>
<p class="body-text">He had paused before her, inches separating them. She froze,
					but her heart thundered. What was he suggesting? Because while his tone was
					brisk, there was a speculative gleam in his eyes. Or was she imagining it?</p>
<p class="body-text">She realized that she was mesmerized, and unbalanced. “I could
					not be more desperate,” she managed, with a stutter.</p>
<p class="body-text">He suddenly reached for her hood and tugged it down before she
					knew what he meant to do. His eyes immediately widened.</p>
<p class="body-text">Her tension knew no bounds. She meant to protest. If she had
					wanted to reveal her face, she would have done so! As his gaze moved over her
					features, very slowly, one by one, her resistance died.</p>
<p class="body-text">“Now I understand,” he said softly, “why you would hide your
					features.”</p>
<p class="body-text">Her heart slammed. Was he complimenting her? Did he think her
					attractive—or even beautiful? “Obviously we are in some jeopardy,” she
					whispered. “I’m afraid of being recognized.”</p>
<p class="body-text">“Obviously. Is your husband French?”</p>
<p class="body-text">“Yes,” she said, “and I have never been as afraid.”</p>
<p class="body-text">He studied her. “I take it you were followed?”</p>
<p class="body-text">“I don’t know—perhaps.”</p>
<p class="body-text">Suddenly he reached toward her. Evelyn lost her ability to
					breathe as he tucked a strand of dark hair behind her ear. Her heart went wild.
					His fingers had grazed her cheek—and she almost wanted to leap into his arms.
					How could he do such a thing? They were strangers.</p>
<p class="body-text">“Was your husband accused of crimes against the state?”</p>
<p class="body-text">She flinched. “No…but we were told not to leave Paris.”</p>
<p class="body-text">He stared.</p>
<p class="body-text">She wet her lips, wishing she could decipher his thoughts, but
					his expression was bland. “Sir—will you help us—please?”</p>
<p class="body-text">She could not believe how plaintive she sounded. But he was
					still crowding her. Worse, she now realized she could feel his body’s warmth and
					heat. And while she was a woman of medium height, he made her feel small and
					fragile.</p>
<p class="body-text">“I am considering it.” He finally paced slowly away. Evelyn
					gulped air, ignoring the wild urge she had to fan herself with the closest
					object at hand. Was he going to reject her plea?</p>
<p class="body-text">“Sir! We must leave the country—immediately. I am afraid for my
					daughter!” she cried.</p>
<p class="body-text">He glanced at her, apparently unmoved. Evelyn had no idea what
					he was thinking, as an odd silence ensued. He finally said, “I will need to know
					who I am transporting.”</p>
<p class="body-text">She bit her lip. She hated deception, but she had no choice.
					“The Vicomte LeClerc,” she lied.</p>
<p class="body-text">His gaze moved over her face another time. “I will take payment
					in advance. My fee is a thousand pounds for each passenger.”</p>
<p class="body-text">Evelyn cried out. “Sir! I hardly have six thousand pounds!”</p>
<p class="body-text">He studied her. “If you have been followed, there will be
					trouble.”</p>
<p class="body-text">“And if we haven’t been followed?”</p>
<p class="body-text">“My fee is six thousand pounds, madam.”</p>
<p class="body-text">She closed her eyes briefly, then reached into her bodice and
					handed him the assignats.</p>
<p class="body-text">He made a disparaging sound. “That is worthless to me.” But he
					laid them on his desk.</p>
<p class="body-text">Evelyn grimly reached into her bodice. He did not look away,
					and she flushed as she removed the diamond-and-ruby necklace. His impassive
					expression did not change. Evelyn walked over to him and handed him the
					necklace.</p>
<p class="body-text">He took the necklace, carried it to his desk and sat down
					there. She watched him take a jeweler’s glass from a drawer and inspect the
					gems. “It is real,” she managed. “That is the most I can offer you, sir, and it
					is not worth six thousand pounds.”</p>
<p class="body-text">He gave her a skeptical glance, his gaze suddenly sliding to
					her mouth, before he continued to study the rubies with great care. Her tension
					was impossible now. He finally set the necklace and glass down. “We have a
					bargain, Vicomtesse. Although it is against my better judgment.”</p>
<p class="body-text">She was so relieved she gasped. Tears formed. “Thank you! I
					cannot thank you enough!”</p>
<p class="body-text">He gave her another odd look. “I imagine you could, if you
					wished to.” Abruptly he stood. “Tell me where your husband is and I will get him
					and your daughter and the others. We will disembark at dawn.”</p>
<p class="body-text">Evelyn had no idea what that strange comment had meant—or, she
					hoped she did not. And she could not believe it—he was going to help them flee
					the country, even if he did not seem overly enthused about it.</p>
<p class="body-text">Relief began. Somehow, she felt certain that this man would get
					them safely out of France and across the Channel. “They are at the Abelard Inn.
					But I am coming with you.”</p>
<p class="body-text">“Oh, ho!” His gaze hardened. “You are hardly coming, as God
					only knows what might arise between the docks and the inn. You can wait
					here.”</p>
<p class="body-text">She breathed hard. “I have already been separated from my
					daughter for an hour! I cannot remain apart from her. It is too dangerous.” And
					she was worried that, if someone discovered her party, they might take Henri
					prisoner—and Aimee, as well.</p>
<p class="body-text">“You will wait here. I am not escorting you back to that inn,
					and if you do not do as I say, you may take back your necklace, and we will
					cancel our agreement.”</p>
<p class="body-text">His gaze had become as sharp as knives. Evelyn was taken
					aback.</p>
<p class="body-text">“Madam, I will guard your daughter with my life, and I intend
					to be back on my ship in a matter of minutes.”</p>
<p class="body-text">She inhaled. Oddly, she trusted him, and clearly, he was not
					going to allow her to come.</p>
<p class="body-text">Aware of her surrender, he opened a drawer and removed a small
					pistol and a bag of powder with a flint box. He closed the drawer and his stare
					was piercing. “The odds are that you will not need this, but keep it with you
					until I return.” He walked around the desk and held the gun out to her.</p>
<p class="body-text">Evelyn took the gun. His eyes had become chilling. But he was
					about to aid and abet traitors to the revolution. If he was caught, he would
					hang—or worse.</p>
<p class="body-text">He strode to the door. “Bolt it,” he said, not looking
					back.</p>
<p class="body-text">Her heart slammed in unison with the door. Then she ran to it
					and threw the bolt, but not before she saw him striding across the ship’s deck,
					two armed sailors falling into step with him.</p>
<p class="body-text">She hugged herself, shivering. And then she prayed for Aimee,
					and for Henri. There was a small bronze clock on the desk; it was five-twenty
					now. She went and sat down in his chair.</p>
<p class="body-text">His masculinity seemed to rise up and engulf her. If only he
					had let her join him to retrieve her daughter and husband. She leaped up from
					his chair and paced. She could not bear sitting in his chair, and she wasn’t
					about to sit on his bed.</p>
<p class="body-text">At a quarter to six, she heard a sharp knock on the cabin door.
					Evelyn rushed to it as he said, “It is I.”</p>
<p class="body-text">She threw the bolt and opened the door. The first thing she saw
					was Aimee, yawning—she was in the smuggler’s arms. Tears began. He stepped into
					the cabin and handed Aimee to her. Evelyn hugged her, hard, but her gaze met
					that of the captain’s. “Thank you.”</p>
<p class="body-text">His glance held hers as he stepped aside.</p>
<p class="body-text">“Evelyn.”</p>
<p class="body-text">She froze at the sound of Henri’s voice. Then, incredulous, she
					saw him being held upright by two seamen. Laurent, Adelaide and Bette were
					behind them. “Henri! You have awakened!” she cried, thrilled.</p>
<p class="body-text">And as the seamen brought him inside, she set Aimee down and
					rushed to him, putting her arm around him to help him stand.</p>
<p class="body-text">“You are not going to England without me,” he said weakly.</p>
<p class="body-text">Tears fell now. Henri had awoken, and he was determined to be
					with them as they started a new life in England. She helped him to the bed,
					where he sat down, still weak and exhausted. Laurent and the women began
					bringing in their baggage as the two seamen left.</p>
<p class="body-text">Evelyn continued to clasp her husband’s hands, but she
					turned.</p>
<p class="body-text">The Englishman was staring at her. “We are hoisting sail,” he
					said abruptly.</p>
<p class="body-text">Evelyn stood, their stares locked. His was so serious. “It
					seems that I must thank you another time.”</p>
<p class="body-text">It was a moment before he spoke. “You can thank me when we
					reach Britain.” He turned to go.</p>
<p class="body-text">It was as if there was an innuendo in his words. And somehow,
					she knew what that innuendo was. But surely she was mistaken. Evelyn did not
					think twice. She ran to him—and in front of him. “Sir! I am deeply in your debt.
					But to whom do I owe the lives of my daughter and my husband?”</p>
<p class="body-text">“You owe Jack Greystone,” he said.</p>
<p class="Basic-Paragraph"></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// PROLOGUE.vue?5764c155